<template>
  <header class="header">
    <HeaderTop />
    <HeaderBottom @open-side-menu="openSideMenu" @open-geo-modal="openGeoModal" />
    <HeaderGlobalSearch />
  </header>
</template>

<script setup lang="ts">
  import HeaderTop from './HeaderTop.vue'
  import HeaderBottom from './HeaderBottom.vue'
  import HeaderGlobalSearch from './HeaderGlobalSearch.vue'

  const emit = defineEmits(['open-side-menu', 'open-geo-modal'])

  const openSideMenu = () => {
    emit('open-side-menu')
  }

  const openGeoModal = () => {
    emit('open-geo-modal')
  }
</script>

<style lang="scss" scoped>
  .header {
    position: sticky;
    top: 0;
    z-index: 55;
  }
</style>
